import { useGetExternalPaymentAccounts } from "@src/appV2/Agents/api/useGetExternalPaymentAccounts";
import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib";
import { BannerLink } from "@src/appV2/lib/Alert";
import { logEvent } from "@src/appV2/lib/analytics";
import { useSupportLinks } from "@src/appV2/support/hooks/useSupportLinks";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { useZendeskArticle } from "@src/appV2/Zendesk/useZendeskArticle";

function DebitCardExpirationAboutToExpireBanner() {
  const { openArticle } = useZendeskArticle();
  const { instantPayInfoSupportLink } = useSupportLinks();
  return (
    <BannerLink
      severity="warning"
      to=""
      onClick={async () => {
        logEvent(APP_V2_USER_EVENTS.TAPPED_DEBIT_CARD_ABOUT_TO_EXPIRE_BANNER);
        await openArticle(instantPayInfoSupportLink);
      }}
    >
      Your debit card is about to expire, tap here to learn how to update your payment information.
    </BannerLink>
  );
}

function DebitCardExpirationExpiredBanner() {
  const { openArticle } = useZendeskArticle();
  const { instantPayInfoSupportLink } = useSupportLinks();
  return (
    <BannerLink
      severity="error"
      to=""
      onClick={async () => {
        logEvent(APP_V2_USER_EVENTS.TAPPED_DEBIT_CARD_EXPIRED_BANNER);
        await openArticle(instantPayInfoSupportLink);
      }}
    >
      Your debit card has expired, tap here to learn how to update your payment information.
    </BannerLink>
  );
}

function DebitCardExpirationBannerContent() {
  const worker = useDefinedWorker();

  const { data: externalPaymentAccounts, status: externalPaymentAccountsStatus } =
    useGetExternalPaymentAccounts({
      workerId: worker.userId,
    });

  if (externalPaymentAccountsStatus !== "success") {
    return null;
  }

  const debitCardExpirationStatus = externalPaymentAccounts.data.find(
    (account) => account.attributes.type === "card"
  )?.attributes.debitCardExpirationStatus;

  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
  switch (debitCardExpirationStatus) {
    case "expiring": {
      return <DebitCardExpirationAboutToExpireBanner />;
    }

    case "expired": {
      return <DebitCardExpirationExpiredBanner />;
    }

    default: {
      return null;
    }
  }
}

export function DebitCardExpirationBanner() {
  const showBanner = useCbhFlag(CbhFeatureFlag.SHOW_DEBIT_CARD_EXPIRATION_BANNER, {
    defaultValue: false,
  });

  if (!showBanner) {
    return null;
  }

  return <DebitCardExpirationBannerContent />;
}
